module.exports = __webpack_public_path__ + "media/excellusbcbs-careers-calendar@xs-682e9e25a8f4f657e49c8482b7455e06.png";